import type { DownloadCostsEnd, DownloadCostsRequest, LoadCostsFailed, LoadCostsRequest, LoadCostsSucceeded, LoadDriverNamesSucceeded } from './actions';
import { ActionTypes } from './actionTypes';

import type { DateRange, DriverNames, FuelCosts, MaintenanceCosts } from '@cobliteam/common-types';

export const loadCostsRequest = (period: DateRange): LoadCostsRequest => ({
  type: ActionTypes.LOAD_COSTS_REQUEST,
  payload: period,
});

export const loadCostsFailed = (): LoadCostsFailed => ({
  type: ActionTypes.LOAD_COSTS_FAILED,
});

export const loadCostsSucceeded = (fuelCosts: FuelCosts, maintenanceCosts: MaintenanceCosts): LoadCostsSucceeded => ({
  type: ActionTypes.LOAD_COSTS_SUCCEEDED,
  payload: { fuelCosts, maintenanceCosts },
});

export const loadDriverNamesSucceeded = (driverNames: DriverNames): LoadDriverNamesSucceeded => ({
  type: ActionTypes.LOAD_DRIVERS_NAME_SUCCEEDED,
  payload: driverNames,
});

export const downloadCostsRequest = (period: DateRange): DownloadCostsRequest => ({
  type: ActionTypes.DOWNLOAD_COSTS_REQUEST,
  payload: period,
});

export const downloadCostsEnd = (): DownloadCostsEnd => ({
  type: ActionTypes.DOWNLOAD_COSTS_END,
});
